export const SET_USERS = 'users/set';
export const ADD_USERS_TO_LIST = 'users/add';
export const EDIT_USERS_IN_LIST = 'users/edit';
export const DELETE_USERS_FROM_LIST = 'users/delete';
export const CLEAR_USERS = 'users/clear';
